'use client';

import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

type ButtonProps = {
    onClick?: () => void;
    disabled?: boolean;
    isLoading?: boolean;
    text: string;
    type?: "submit" | "reset" | "button" | undefined;
};

const Button: React.FC<ButtonProps> = ({ onClick, isLoading = false, type, disabled = false, text }) => {
    return (
        <button
            onClick={onClick}
            disabled={disabled || isLoading}
            type={type}
            className={`buttonH`} >
            { isLoading 
                ? <FontAwesomeIcon icon={faSpinner} pulse/> 
                : text }
        </button>
    );
};

export default Button;
